import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ClassViewLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'CalendarsLazy' */ './components/ClassView')
);

export default (store) => {
	return {
		path: 'class-view/:campusId?',
		element: <AsyncLoading component={<ClassViewLazy />} />,
		children: [],
	};
};
